import { logger as E } from "../../shared-lib/index.js";
import { DUST_SHARED_WORKER_CODE as ri } from "./dust-shared-worker-code.js";
export function isSharedWorkerSupported() {
  return "undefined" != typeof SharedWorker;
}
export class DustWorkerBridge {
  constructor(i) {
    (this.Wr = null),
      (this.Lr = null),
      (this.isConnected = !1),
      (this.Ir = null),
      (this.Mr = null),
      (this.we = i.we),
      (this.ke = i.ke),
      (this.Re = i.Re),
      (this.Me = i.Me);
  }
  initialize() {
    if (!isSharedWorkerSupported())
      return (
        E.info("SharedWorker not supported, will use direct connection"), !1
      );
    try {
      const i = new Blob([ri], { type: "application/javascript" });
      return (
        (this.Lr = URL.createObjectURL(i)),
        (this.Wr = new SharedWorker(this.Lr, { name: "braze-dust-worker" })),
        (this.Wr.port.onmessage = (i) => {
          this.Br(i.data);
        }),
        (this.Wr.port.onmessageerror = () => {
          E.warn("Message error from real-time messaging worker");
        }),
        (this.Wr.onerror = (i) => {
          var e;
          E.error(
            `Real-time messaging worker error: ${i.message || "unknown error"}`,
          ),
            null === (e = this.Me) ||
              void 0 === e ||
              e.call(this, "SharedWorker error");
        }),
        this.Wr.port.start(),
        this.Ur(),
        this.Vr(),
        E.info("Real-time messaging worker initialized"),
        !0
      );
    } catch (i) {
      return (
        E.error(
          `Failed to create real-time messaging worker: ${
            i instanceof Error ? i.message : String(i)
          }`,
        ),
        this.Er(),
        !1
      );
    }
  }
  Br(i) {
    var e, t, s;
    switch (i.type) {
      case "connected":
        E.info("Real-time messaging connection established via SharedWorker"),
          (this.isConnected = !0),
          null === (e = this.ke) || void 0 === e || e.call(this);
        break;
      case "disconnected":
        E.info("Real-time messaging connection closed via SharedWorker"),
          (this.isConnected = !1),
          null === (t = this.Re) || void 0 === t || t.call(this);
        break;
      case "message":
        this.we(i.data);
        break;
      case "error":
        E.error(`Real-time messaging error: ${i.error}`),
          null === (s = this.Me) || void 0 === s || s.call(this, i.error);
    }
  }
  Ur() {
    this.Ir = window.setInterval(() => {
      this.Wr && this._r({ type: "ping" });
    }, 3e4);
  }
  qr() {
    null !== this.Ir && (window.clearInterval(this.Ir), (this.Ir = null));
  }
  Vr() {
    (this.Mr = () => {
      "visible" === document.visibilityState &&
        this.Wr &&
        this._r({ type: "tab_active" });
    }),
      document.addEventListener("visibilitychange", this.Mr);
  }
  Ar() {
    this.Mr &&
      (document.removeEventListener("visibilitychange", this.Mr),
      (this.Mr = null));
  }
  _r(i) {
    this.Wr && this.Wr.port.postMessage(i);
  }
  connect(i) {
    this.Wr
      ? (this._r({ type: "connect", pn: i }),
        E.info("Connecting to real-time messaging"))
      : E.error("Cannot connect: real-time messaging worker not initialized");
  }
  disconnect() {
    this.Wr &&
      (this._r({ type: "disconnect" }),
      (this.isConnected = !1),
      E.info("Disconnecting from real-time messaging"));
  }
  Ie() {
    return this.isConnected;
  }
  isInitialized() {
    return null !== this.Wr;
  }
  Er() {
    this.qr(),
      this.Ar(),
      this.Wr && (this.Wr.port.close(), (this.Wr = null)),
      this.Lr && (URL.revokeObjectURL(this.Lr), (this.Lr = null)),
      (this.isConnected = !1);
  }
  destroy() {
    this.disconnect(),
      this.Er(),
      E.info("Real-time messaging worker destroyed");
  }
}
